import { ConfirmationModal } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';
import styles from './ConfirmationModal.module.css';

export const RequestSignByEmailModal = ({
  showModal,
  onCloseModal,
  onSendEmail,
}: {
  showModal: boolean;
  onCloseModal: () => void;
  onSendEmail: () => void;
}) => {
  const { getTranslation } = useTranslate();
  return (
    <ConfirmationModal
      className={styles.width480}
      show={showModal}
      onClose={onCloseModal}
      onPrimaryButtonClick={onSendEmail}
      onSecondaryButtonClick={onCloseModal}
      primaryButtonName={getTranslation('common_sendEmail')}
      secondaryButtonName={getTranslation('common_status_cancel')}
      title={getTranslation('request_agreement_signature')}
    />
  );
};
